import React from 'react';
import { graphql } from 'gatsby';
import { HtmlContent } from '../../../htmlContent/HtmlContent';

export const Html = ({ data: { content }, ...rest }) => (
  <HtmlContent {...rest}>{content}</HtmlContent>
);

export const HtmlQuery = graphql`
  fragment Html on UMBRACO_HtmlComponentType {
    content
  }
`;
